import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const t = localStorage.getItem("es_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});
